import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import Moment from 'react-moment';
import moment from 'moment'; 

var Config = require('../../../config');

class ModalPatient extends Component{
	constructor(props){
		super(props);

		this.state = {
			show: false,
			title:"",
			complete:true,
		}

		this.handleShow  = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.selectPatient = this.selectPatient.bind(this);
		this.loadPatient = this.loadPatient.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);
	}


	handleShow(title, complete){
		this.setState({
			show:true,
			title:title,
			complete:complete
		});


	}

	handleClose(){
		this.setState({
			show:false,
			title:"",
			complete:true
		});

	}

	selectPatient(e, i){
		var list = this.props.state.list;

		list.map((l, j)=>{
			if(i === j){

				l.check = e.target.checked ? true : false;
			}else{
				l.check = false;
			}
		})


		//list[i].check = e.target.checked ? true : false;

		this.props.update(list);
	}

	loadPatient(e){
		e.preventDefault();
		var index = this.props.state.list.findIndex(obj => obj.check === true);

		if(index !== -1){
			this.props.load(this.props.state.list[index]);
			
			this.handleClose();	
		}else{
			swal('Error', 'No ha seleccionado ningun registro', 'error');
		}
		
	}

	render(){
		const { t } = this.props;

		return (
			<div>
				<Modal bsSize="lg" dialogClassName="modal-patient" show={this.state.show} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>{this.state.title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
							<div className="col-xs-12">
								<Table responsive hover style={{tableLayout:"fixed"}}>
									<thead>
										<tr>
											<th width={10}></th>
											<th width={100}>Agregado Médico</th>
											<th width={150}>IDEE</th>
											<th width={150}>Nombre</th>
											<th width={100}>Reg. Patronal</th>
											<th width={100}>T. Pensión</th>
											<th width={100}>Cve. Unidad</th>
											<th width={100}>Consultorio</th>
											<th width={150}>CURP</th>
											<th width={100}>Derecho Incapacidad</th>
											<th width={100}>F. Nacimiento</th>
											<th width={100}>F. Fin Vigencia</th>
											<th width={100}>NSS</th>
											<th width={100}>Sexo</th>
											<th width={100}>Estatus Servicio Médico</th>
											<th width={100}>T. Paciente</th>
											<th width={100}>F. Defunción</th>
											<th width={500}>Domicilio</th>
											<th width={100}>Teléfono</th>
											<th width={100}>Turno</th>
											<th width={100}>Procedencia</th>
											<th width={100}>Convenio</th>
											<th width={100}>Observaciones</th>
										</tr>
									</thead>
									<tbody>
										{this.props.state.list.map((list, i)=>(
											<tr key={i}>
												<td>
													<input type="checkbox" value={list.check} checked={list.check}
														onChange={(e)=>this.selectPatient(e, i)} />
												</td>
												<td>{list.AGREGADO_MEDICO}</td>
												<td>{list.IDEE}</td>
												<td>
													{list.PRIMER_APELLIDO+' '+
													list.SEGUNDO_APELLIDO+' '+
													list.NOMBRE}
												</td>
												<td>{list.CLAVE_REGISTRO_PATRONAL}</td>
												<td>{list.CLAVE_TIPO_PENSION}</td>
												<td>{list.CLAVE_UNIDAD}</td>
												<td>{list.CONSULTORIO}</td>
												<td>{list.CURP}</td>
												<td>{list.DERECHO_INCAPACIDAD}</td>
												<td>{moment(list.FECHA_NACIMIENTO.DateTime).format('DD/MM/YYYY')}</td>
												<td>{list.FECHA_LIMITE_VIGENCIA !== null? moment(list.FECHA_LIMITE_VIGENCIA.DateTime).format('DD/MM/YYYY'):""}</td>
												<td>{list.NSS}</td>
												<td>{list.SEXO}</td>
												<td>{list.SITUACION}</td>
												<td>{list.TIPO_PACIENTE}</td>
												<td>{list.FECHA_DEF !== null?(moment(list.FECHA_DEF.DateTime).format('DD/MM/YYYY')):""}</td>
												<td width={500}>{list.CALLE+", "+list.COLONIA}</td>
												<td>{list.TELEFONO}</td>
												<td>{list.TURNO}</td>
												<td>{list.CVE_PROCEDENCIA}</td>
												<td>{list.CVE_TIPO_CONVENIO}</td>
												<td>{list.OBSERVACIONES_CONVENIO}</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<FlatButton primary={true} label={t('content.generics.buttons.select')}  onClick={this.loadPatient}/>
			        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
				</Modal>
			</div>
		)
	}
}

export default ModalPatient;